import { createAsyncThunk } from "@reduxjs/toolkit";
import { useGetData } from "../../../hooks/useGetData";
import { useInsertData } from "../../../hooks/useInsertData";
import notify from "../../../components/notify";
import { useDeleteData } from "../../../hooks/useDeleteData";
import i18n from "../../../i18n/i18n";

// ✅ ADS (Book a Date)  =>  /book-a-date

export const getAllAds = createAsyncThunk(
  "/adsSlice/getAllAds",
  async () => {
    try {
      const response = await useGetData(`/book-a-date?page=1&limit=100`);
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        return notify(i18n.t("network_error_message"), "error");
      } else {
        return notify(error.response?.data, "error");
      }
    }
  },
);

